import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Form, Formik } from 'formik';
import HTTPMethod from 'http-method-enum';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import * as Yup from 'yup';
import { LEAD_FORM_COMPLETED, LEAD_FORM_COMPLETED_CONVERSION, LEAD_FORM_COMPLETED_FACEBOOK } from '@store/constants/analyticEvents';
import { ACTION_WAITLIST_SIGNUP } from '@store/constants/recaptcha';
import { API_WAITLIST_CUSTOMER, PAGE_PRIVACY_POLICY } from '@store/constants/routes';
import { usePersistedQueryParameters } from '@store/hooks/usePersistedQueryParameters';
import useReCaptcha from '@store/hooks/useReCaptcha';
import { trackEvent as trackSplitEvent } from '@store/utils/split';
import { Trans, useTranslation } from '@yoweb/next-i18next';
import { Box } from '@yoweb/ui/components/Box';
import { Button, ButtonLink } from '@yoweb/ui/components/buttons';
import { ErrorDisplay, Input, useError } from '@yoweb/ui/components/form';
import NameGrid from '@yoweb/ui/components/NameGrid';
import { Interactive } from '@yoweb/ui/components/typography';
import { useIntlMeta } from '@yoweb/ui/hooks/useIntlMeta';
import { getSpace } from '@yoweb/ui/styles/utils/theme';
import { trackConversion, trackEvent } from '@yoweb/utils/analytics/google';
import { emitCustomEvent } from '@yoweb/utils/analytics/facebook';
import { fetchJson } from '@yoweb/utils/fetchJson';
import hasFullWidthChars from '@yoweb/utils/intl/hasFullWidthChars';
import { postalCodeOnChangeHandler, postalCodeOnPasteHandler, validatePostalCode } from '@yoweb/utils/postalCode';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SPLIT_TRAFFIC_TYPE = 'anonymous';
var SPLIT_EVENTS = {
  SUBMIT: 'waitlist.submit.anonymous',
  VIEW: 'waitlist.view.anonymous'
};
export var WaitlistForm = function WaitlistForm(_ref) {
  var _utmParameters$utm_so, _utmParameters$utm_ca, _utmParameters$utm_me, _utmParameters$utm_te, _utmParameters$utm_co;

  var onComplete = _ref.onComplete,
      referralCodeProp = _ref.referralCode,
      buttonLabel = _ref.buttonLabel,
      treatment = _ref.treatment;

  var _useTranslation = useTranslation(['waitlist', 'common']),
      t = _useTranslation.t;

  var _useIntlMeta = useIntlMeta(),
      country = _useIntlMeta.country,
      localeHasFullWidthChars = _useIntlMeta.localeHasFullWidthChars,
      lcLocale = _useIntlMeta.lcLocale;

  var errorDisplay = useError();
  var reCaptcha = useReCaptcha();

  var _usePersistedQueryPar = usePersistedQueryParameters(),
      getPersistedParameter = _usePersistedQueryPar.getPersistedParameter;

  var _useState = useState(null),
      referralCode = _useState[0],
      setReferralCode = _useState[1];

  useEffect(function () {
    setReferralCode(referralCodeProp || getPersistedParameter('referralCode') || '');

    if (treatment) {
      void trackSplitEvent(SPLIT_TRAFFIC_TYPE, SPLIT_EVENTS.VIEW, 1, {
        variant: treatment
      });
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  var utmParameters = getPersistedParameter('utm_params');
  var userAttribution = utmParameters ? {
    utmSource: (_utmParameters$utm_so = utmParameters['utm_source']) !== null && _utmParameters$utm_so !== void 0 ? _utmParameters$utm_so : '',
    utmCampaign: (_utmParameters$utm_ca = utmParameters['utm_campaign']) !== null && _utmParameters$utm_ca !== void 0 ? _utmParameters$utm_ca : '',
    utmMedium: (_utmParameters$utm_me = utmParameters['utm_medium']) !== null && _utmParameters$utm_me !== void 0 ? _utmParameters$utm_me : '',
    utmTerm: (_utmParameters$utm_te = utmParameters['utm_term']) !== null && _utmParameters$utm_te !== void 0 ? _utmParameters$utm_te : '',
    utmContent: (_utmParameters$utm_co = utmParameters['utm_content']) !== null && _utmParameters$utm_co !== void 0 ? _utmParameters$utm_co : ''
  } : undefined;

  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(values, helpers) {
      var _window, reCaptchaToken, referralCodeTrimmed, data;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              errorDisplay.clear();
              _context.prev = 1;
              _context.next = 4;
              return reCaptcha.execute(ACTION_WAITLIST_SIGNUP);

            case 4:
              reCaptchaToken = _context.sent;
              referralCodeTrimmed = values.referralCode.trim();
              _context.next = 8;
              return fetchJson(API_WAITLIST_CUSTOMER, {
                method: HTTPMethod.POST,
                body: JSON.stringify({
                  referralCode: referralCodeTrimmed,
                  postalCode: values.postalCode.trim(),
                  name: {
                    firstName: values.firstName.trim(),
                    lastName: values.lastName.trim()
                  },
                  emailAddress: {
                    address: values.email.trim()
                  },
                  userAttribution: userAttribution,
                  reCaptchaToken: reCaptchaToken,
                  locale: lcLocale
                })
              });

            case 8:
              data = _context.sent;
              // send custom GA event and Facebook event when waitlist for is submitted
              trackEvent(_objectSpread(_objectSpread({}, LEAD_FORM_COMPLETED), {}, {
                value: {
                  page_url: (_window = window) === null || _window === void 0 ? void 0 : _window.location.href,
                  zip_code: values.postalCode
                },
                nonInteraction: false
              }));
              trackConversion(LEAD_FORM_COMPLETED_CONVERSION);
              emitCustomEvent(LEAD_FORM_COMPLETED_FACEBOOK);

              if (treatment) {
                void trackSplitEvent(SPLIT_TRAFFIC_TYPE, SPLIT_EVENTS.SUBMIT, 1, {
                  variant: treatment
                });
              }

              onComplete(data.inviteCode, values.firstName.trim());
              _context.next = 21;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](1);
              errorDisplay.set();
              helpers.setSubmitting(false);
              throw _context.t0;

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 16]]);
    }));

    return function onSubmit(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var initialValues = {
    firstName: '',
    lastName: '',
    email: '',
    postalCode: '',
    referralCode: referralCode !== null && referralCode !== void 0 ? referralCode : ''
  };
  var schema = Yup.object().shape({
    firstName: Yup.string().trim().required(t('common:validation.required')),
    lastName: Yup.string().trim().required(t('common:validation.required')),
    email: Yup.string().email(t('common:validation.invalid-email')).trim().test({
      message: t('common:validation.enter-half-width-characters'),
      test: function test(value) {
        return value && localeHasFullWidthChars ? !hasFullWidthChars(value) : true;
      }
    }).required(t('common:validation.required')),
    postalCode: Yup.string().trim().test({
      message: t('common:validation.zip-code'),
      test: function test(value) {
        return value ? validatePostalCode(country, value) : false;
      }
    }).required(t('common:validation.required')),
    referralCode: Yup.string()
  });
  return /*#__PURE__*/_jsx(Formik, {
    onSubmit: onSubmit,
    initialValues: initialValues,
    validationSchema: schema,
    enableReinitialize: true,
    children: function children(_ref3) {
      var isSubmitting = _ref3.isSubmitting;
      return /*#__PURE__*/_jsxs(Form, {
        "data-testid": "waitlist-form",
        children: [/*#__PURE__*/_jsx(ErrorDisplay, _objectSpread(_objectSpread({
          withBorder: true
        }, errorDisplay), {}, {
          "data-testid": "waitlist-form-error"
        })), /*#__PURE__*/_jsxs(FormWrap, {
          children: [/*#__PURE__*/_jsxs(NameGrid, {
            needsPronunciationFields: false,
            rowGap: "normal1",
            children: [/*#__PURE__*/_jsx(Input, {
              name: "firstName",
              id: "firstName",
              "data-testid": "firstName",
              label: t('waitlist:personal.firstName'),
              maxLength: 40
            }), /*#__PURE__*/_jsx(Input, {
              name: "lastName",
              id: "lastName",
              "data-testid": "lastName",
              label: t('waitlist:personal.lastName'),
              maxLength: 40
            })]
          }), /*#__PURE__*/_jsx(Input, {
            name: "email",
            id: "email",
            "data-testid": "email",
            label: t('waitlist:personal.email'),
            enforceCharacterWidth: "half"
          }), /*#__PURE__*/_jsx(Input, {
            name: "postalCode",
            id: "postalCode",
            inputMode: "numeric",
            "data-testid": "postalCode",
            label: t('waitlist:personal.postalCode'),
            onChange: function onChange(e) {
              return postalCodeOnChangeHandler(e, country);
            },
            onPaste: function onPaste(e) {
              return postalCodeOnPasteHandler(e, country);
            },
            enforceCharacterWidth: "half"
          }), /*#__PURE__*/_jsx(Input, {
            name: "referralCode",
            id: "referralCode",
            "data-testid": "referralCode",
            label: t('waitlist:personal.promoCode'),
            maxLength: 64
          })]
        }), /*#__PURE__*/_jsx(Interactive, {
          size: "sm",
          variant: "muted",
          children: /*#__PURE__*/_jsx(Trans, {
            t: t,
            i18nKey: "waitlist:lifestyle.privacy-policy",
            components: [/*#__PURE__*/_jsx(ButtonLink, {
              as: "a",
              href: PAGE_PRIVACY_POLICY,
              size: "sm",
              weight: "semibold",
              variant: "muted",
              target: "_blank"
            }, 0)]
          })
        }), /*#__PURE__*/_jsx(Box, {
          display: "flex",
          justifyContent: "flex-end",
          mt: {
            _: 'normal3',
            md: 'normal4'
          },
          children: /*#__PURE__*/_jsx(Button, {
            isLoading: isSubmitting,
            type: "submit",
            "data-testid": "waitlist-submit",
            text: buttonLabel ? buttonLabel : t('common:submit'),
            size: "lg"
          })
        })]
      });
    }
  });
};
var FormWrap = styled.div.withConfig({
  componentId: "sc-1qoagrn-0"
})(["display:grid;padding:", " 0;row-gap:", ";"], getSpace('normal2'), getSpace('normal1'));